import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';

import {
  modalDotSx,
  modalPercentageSx,
  modalRowSx,
  modalTitleSx,
  modalTotalRowSx,
} from './chart.styles';
import type { ChartTooltipRow } from './ChartTooltip';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  total: string;
  rows: ChartTooltipRow[];
}

const ChartDetailModal: React.FC<Props> = ({ open, onClose, title, total, rows }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle sx={modalTitleSx}>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>{title}</Typography>
      <IconButton size="small" onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <Divider />
    <DialogContent sx={{ pt: 1.5 }}>
      <Box sx={modalTotalRowSx}>
        <Typography sx={{ fontWeight: 600, fontSize: 14 }}>Project</Typography>
        <Typography sx={{ fontWeight: 600, fontSize: 14 }}>{total}</Typography>
      </Box>

      {rows.map((row, i) => (
        <Box key={i} sx={modalRowSx(i === rows.length - 1)}>
          <Box sx={modalDotSx(row.color)} />
          <Typography sx={{ fontSize: 13, flex: 1 }}>{row.label}</Typography>
          <Typography sx={{ fontSize: 13, fontVariantNumeric: 'tabular-nums', flexShrink: 0 }}>
            {row.duration}
          </Typography>
          {row.percentage && (
            <Typography sx={modalPercentageSx}>{row.percentage}</Typography>
          )}
        </Box>
      ))}
    </DialogContent>
  </Dialog>
);

export default ChartDetailModal;
